import type { ExcIncreaseV1AccountNumberKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const INCREASE_ACCOUNT_NUMBER_BASE_PATH = getResolvedPath('/clearing/vendor/increase/account-number');

export const getIncreaseAccountNumberPath: EntityPathBuilder<ExcIncreaseV1AccountNumberKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return INCREASE_ACCOUNT_NUMBER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.accountNumberId) {
        return undefined;
      }

      return getResolvedPath(`${INCREASE_ACCOUNT_NUMBER_BASE_PATH}/$accountNumberId`, context.keys);
    }
  }
};

export function getIncreaseAccountNumberDetailPath(accountNumberId: string | undefined) {
  if (!accountNumberId) {
    return undefined;
  }

  return getIncreaseAccountNumberPath({ kind: 'detail', keys: { accountNumberId } });
}
